import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  templateUrl: 'invalid-passthrough-wrapper.component.html',
})
export class InvalidPassthroughWrapperComponent extends FieldWrapper {
}
